module.exports = __webpack_public_path__ + "static/insurance2-c6d644a3cf039b123dd6aa83b3129e3f.png";